import { SET_IS_LOADING_COS, SET_CUSTOMER_COS } from './constants.js'

/**
 * Get the list of customer COs
 */
export const getCos = function ({dispatch, commit}, payload = {}) {
	commit(SET_IS_LOADING_COS, true)
	// form our api payload
	let apiPayload = payload
	apiPayload.apiEndpoint = 'account'
	apiPayload.postData = {}
	apiPayload.postData.action = 'get_customer_cos'
	dispatch('apiCall', apiPayload).then((response) => {
		commit(SET_IS_LOADING_COS, false)
		if (typeof response.data.payload !== 'undefined') {
			commit(SET_CUSTOMER_COS, response.data.payload)
		}
	})
}
